import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getActiveDirectoryAuthToken } from "utils/getActiveDirectoryAuthToken";
import { v4 as uuidv4 } from "uuid";

// Base RTK Query API setup for user service API calls.
export const userServiceApiSlice = createApi({
  reducerPath: "userServiceApi",
  baseQuery: fetchBaseQuery({
    // Set the base URL for the userServiceApi.
    baseUrl: `${process.env.REACT_APP_API_BASE_URL}/api`,
    // Prepare headers function is used to set the headers for each request to the userServiceApi.
    prepareHeaders: async (headers, { getState, endpoint }) => {
      // Set the Content-Type header to "application/json" for all endpoints except "updateUserOrgStatusBatchWithExcel" which will be auto set by the browser.
      if (endpoint !== "updateUserOrgStatusBatchWithExcel") {
        headers.set("Content-Type", "application/json");
      }

      headers.set("x-correlation-id", uuidv4());

      // Fetch fresh authToken from Active Directory and append it to the headers. (Handles token refresh if expired.)
      const authToken = await getActiveDirectoryAuthToken();
      headers.set("Authorization", `Bearer ${authToken}`);
      return headers;
    },
  }),
  // Tag types are used to group endpoints together in the Redux store.
  tagTypes: ["User", "UserTrackers"],
  endpoints: (builder) => ({}),
});
